import { CSSProperties, memo } from 'react';
import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';
import { IconName } from './utils/types';
import { IconsMap } from './utils/constants';

export interface IconProps {
  className?: string;
  focus?: boolean;
  name: IconName;
  role?: string;
  width?: number | string;
  height?: number | string;
  testId?: string;
  style?: CSSProperties;
}

const Icon = (props: IconProps) => {
  const { focus = false, width, height, name, testId, style, ...other } = props;
  const Component = IconsMap.get(name);
  const sizeProps = omitBy({ width, height }, isNil);

  if (!Component) {
    return null;
  }

  return (
    <Component
      style={style}
      data-testid={testId}
      {...sizeProps}
      {...other}
      focusable={focus}
    />
  );
};

export default memo(Icon);
